import { useEffect } from "react";
import { isMobile, isTablet, useDeviceData } from "react-device-detect";
import { useLocation } from "react-router";
import { ClientAccessTypeEnum } from "../../common/enums/ClientAccessTypeEnum";
import { getRouteFromPath } from "../../common/utilities/RouteHelpers";
import { useOfflineDetectContext } from "../../contexts/offline-detect-context/UseOfflineDetectContext";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { useLogUserActivity } from "../../queries/user-activity-log/UseLogUserActivity";
import { IUserActivityLogItem } from "../../services/user-activity-log-service/Models";

export default function UserActivityLogger() {
    const location = useLocation();
    const deviceData = useDeviceData(window.navigator.userAgent);
    const [userState] = useUserContext();
    const [offlineState] = useOfflineDetectContext();
    const { mutate: logUserActivity } = useLogUserActivity({
        customerID: userState.customer?.id as number,
        offline: offlineState.offline
    });
    const isPhone = isMobile && !isTablet;

    useEffect(() => {
        const currentRoute = getRouteFromPath(location.pathname);

        if(currentRoute && !currentRoute.excludeFromActivityLog){
            const clientInfo = {
                screen: {
                    width: window.screen.width,
                    height: window.screen.height,
                    orientation: window.screen.orientation?.type
                },
                browser: {
                    name: deviceData.browser?.name,
                    version: deviceData.browser?.version
                },
                device: {
                    vendor: deviceData.device?.vendor,
                    model: deviceData.device?.model,
                    type: deviceData.device?.type
                },
                os: {
                    name: deviceData.os?.name,
                    version: deviceData.os?.version
                },
                network: {
                    offline: offlineState.offline
                }
            };
    
            const logItem: IUserActivityLogItem = {
                clientAccessType: isPhone 
                    ? ClientAccessTypeEnum.eLynxMobile
                    : ClientAccessTypeEnum.eLynxDesktop,
                activityName: `${currentRoute.path}${location.search}`,
                timestamp: (new Date()).toISOString(),
                clientInfo: JSON.stringify(clientInfo)
            };
    
            logUserActivity(logItem);
        }
    }, [
        location.pathname,
        location.search,
        logUserActivity,
        deviceData.browser?.name,
        deviceData.browser?.version,
        deviceData.device?.model,
        deviceData.device?.type,
        deviceData.device?.vendor,
        deviceData.os?.name,
        deviceData.os?.version,
        offlineState.offline,
        isPhone
    ]);

    return <></>;
}
